module.exports = require('graphology-pagerank');
